<po-widget class="po-lg-12 po-mb-1">
    <ng-content></ng-content>
    <div class="po-lg-12 po-mb-1 po-mt-3">
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-left">
            <po-button p-label="Limpar" (p-click)="cleanFilter()"></po-button>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-right">
            <po-button p-label="Aplicar filtro" p-icon="an an-list-magnifying-glass" (p-click)="onFilter()"></po-button>
        </div>
    </div>
</po-widget>